// extracted by mini-css-extract-plugin
export default {"card":"card-type_card__pGI2l","active":"card-type_active__xYAFD"};